query AdminDashboard(
  $dateFrom: DateTime!
  $dateTo: DateTime!
  $compareFrom: DateTime
  $compareTo: DateTime
) {
  adminDashboard(
    dateFrom: $dateFrom
    dateTo: $dateTo
    compareFrom: $compareFrom
    compareTo: $compareTo
  ) {
    dateFrom
    dateTo
    step
    current {
      salesUSD
      grossSalesUSD
      refundsUSD
      disputesUSD
      purchasesCount
      revenueShareUSD
      licensesAccruedUSD
      earnedUSD
      issuedInvoicesUSD
      issuedInvoicesCount
      paidInvoicesUSD
      paidInvoicesCount
      paidRevenueShareUSD
      paidLicensesUSD
      expensesUSD
      expensesCount
      netIncomeUSD
      accrualProfitUSD
      organizationsWithSalesCount
      newOrganizationsCount
    }
    previous {
      salesUSD
      grossSalesUSD
      refundsUSD
      disputesUSD
      purchasesCount
      revenueShareUSD
      licensesAccruedUSD
      earnedUSD
      issuedInvoicesUSD
      issuedInvoicesCount
      paidInvoicesUSD
      paidInvoicesCount
      paidRevenueShareUSD
      paidLicensesUSD
      expensesUSD
      expensesCount
      netIncomeUSD
      accrualProfitUSD
      organizationsWithSalesCount
      newOrganizationsCount
    }
    series {
      date
      salesUSD
      revenueShareUSD
      paidInvoicesUSD
      expensesUSD
      netIncomeUSD
      views
      viewers
    }
    organizations {
      organizationId
      title
      salesUSD
      previousSalesUSD
      revenueShareUSD
      paidInvoicesUSD
      views
    }
    expensesByCategory {
      category
      amountUSD
      count
    }
  }
}
